import useResizeObserver from '@react-hook/resize-observer';
import { MutableRefObject, useEffect, useState } from 'react';

export const useClientSize = (target: MutableRefObject<HTMLElement | null>) => {
  const [width, setWidth] = useState<number | null>(null);
  const [height, setHeight] = useState<number | null>(null);

  useEffect(() => {
    if (target.current) {
      setWidth(target.current.clientWidth);
      setHeight(target.current.clientHeight);
    }
  }, [target.current]);

  useResizeObserver(target, (entry) => setWidth(entry.contentRect.width));
  useResizeObserver(target, (entry) => setHeight(entry.contentRect.height));

  return { width, height };
};
